import { AdminUserPostState, CachedInstances } from ".";

export const SET_SELECTED_STATION = async (
  state: AdminUserPostState,
  station?: string
) => {
  state.selectedStation = station;
};

export const SET_SELECTED_BINDING = async (
  state: AdminUserPostState,
  instanceId?: string
) => {
  state.selectedBinding = instanceId;
};

export const SET_CACHED_INSTANCES = async (
  state: AdminUserPostState,
  cached?: CachedInstances
) => {
  state.cachedInstances = cached;
};
